'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    displayClassNames: function() {
        return displayClassNames;
    },
    useDisplayStyles: function() {
        return useDisplayStyles;
    }
});
const _react = require("@griffel/react");
const displayClassNames = {
    root: 'fui-Display'
};
const useDisplayStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fpyltcb",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1ivgwrt"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fpyltcb{font-size:var(--fontSizeHero1000);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1ivgwrt{line-height:var(--lineHeightHero1000);}"
    ]
});
